
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";

import Navbar from "../components/navbar/Navbar";

import { useEffect } from "react";

import Privacy from "../components/Privacy";
import Terms from "../components/Termsandconditions";


const TermsandConditions=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="bg-light">
<Navbar/>
 <Banner title="Terms and Conditions"/>

<Terms/>
<Footer/>

</div>
    )
}
export default TermsandConditions;